<template>
  <div>
    <v-dialog v-model="dialogUpdateGroupPosition" persistent max-width="800px">
    <v-card class="pa-4">
      <v-card-title>
        <span class="dialog-member-title">กลุ่ม: {{ groupDetail.positionGroupName }}</span>
        <v-btn x-small icon class="ml-1" @click="openDialogUpdateGroupName()">
          <v-icon size="20" style="color: #3ca89f;">mdi-pencil-outline</v-icon>
        </v-btn>
        <v-row justify="end" style="margin-top: -3%;">
          <v-btn
            x-small
            icon
            @click="closeDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <tablePositionGroup :setup="positionGroupList" :group-detail="groupDetail" :loading="loading" />
      </v-card-text>
    </v-card>
  </v-dialog>
  <DialogDeletePositionInGroup />
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import tablePositionGroup from '../_update/tablePositionLevelGroup.vue'
import DialogDeletePositionInGroup from './dialogDeletePositionLevelInGroup.vue'

export default {
  components: {
    tablePositionGroup,
    DialogDeletePositionInGroup
  },
  data () {
    return {
      dialogUpdateGroupPosition: false,
      groupDetail: {},
      positionGroupList: [],
      loading: true
    }
  },
  mounted () {
    EventBus.$on('opendialogUpdateGroupPosition', this.openDialogUpdateGroupPosition)
    EventBus.$on('closeDialog', this.closeDialog)
    EventBus.$on('confirmedDelete', this.confirmedDelete)
    EventBus.$on('clearSearch', this.resetTable)
    EventBus.$on('deletePositionLevelInGroup', this.deletePositionInGroup)
  },
  beforeDestroy () {
    EventBus.$off('opendialogUpdateGroupPosition')
    EventBus.$off('closeDialog')
    EventBus.$off('confirmedDelete')
    EventBus.$off('clearSearch')
    EventBus.$off('deletePositionLevelInGroup')
  },
  methods: {
    openDialogUpdateGroupPosition (value) {
      this.setupTableGroup(value)
      this.groupDetail = value
      this.dialogUpdateGroupPosition = true
    },
    closeDialog () {
      this.positionGroupList = []
      this.dialogUpdateGroupPosition = false
    },
    openDialogUpdateGroupName () {
      this.closeDialog()
      EventBus.$emit('callDialogUpdateGroupName', this.groupDetail)
    },
    confirmedDelete () {
      this.closeDialog()
      EventBus.$emit('refreshTablePositionLevelGroup')
    },
    deletePositionInGroup (positionId) {
      const data = {
        positionId: positionId,
        positionGroupId: this.groupDetail._id
      }
      EventBus.$emit('opendialogDeletePositionInGroup', data)
    },
    setupTableGroup (value) {
      this.loading = true
      if (value.positionLevelList && value.positionLevelList.length > 0) {
        const temp = []
        value.positionLevelList.forEach((v, index) => {
          temp.push({
            no: index + 1,
            ...v
          })
        })
        this.positionGroupList = temp
      } else {
        this.positionGroupList = []
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
@import '../../../css/ManageEmployee.css';
.dialog-memeber-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.2rem;
}
</style>
